import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import { Notify } from 'components/Notifications/Notifications';

export const rtkQueryErrorHandler: Middleware =
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (api: MiddlewareAPI) => (next) => (action) => {
    if (
      isRejectedWithValue(action) &&
      (action.payload as { status?: number })?.status >= 500
    ) {
      Notify.error('An error occurred. Please try again.');
    }

    return next(action);
  };

export default rtkQueryErrorHandler;
